<style>
  .paymentMethods {
    width: 60%;
  }

  .paymentMethodRow {
    margin-bottom: 50px;
    width: 90%;
    background-color: #ffffff;
    border: 1px solid var(--colorSelectedItem);
    border-radius: 8px;
    filter: drop-shadow(1px 1px 1px #888888);
    cursor: pointer;
  }

  .paymentMethodRow > div {
    display: inline-block;
    padding: 10px 10px 10px 10px;
  }

  .paymentMethodRow:hover {
    background-color: #f0f0f0;
  }

  .deletePaymentMethod {
    margin-bottom: 5px;
    width: 10%;
    background-color: #ffffff;
    border: 1px solid var(--colorSelectedItem);
    border-radius: 8px;
    filter: drop-shadow(1px 1px 1px #888888);
    cursor: pointer;
  }

  .deletePaymentMethod:hover {
    background-color: #f0f0f0;
  }

  .paymentMethodRow.selected {
    background-color: var(--colorSelectedItem);
    /* cursor: default; */
    filter: drop-shadow(1px 1px 0px var(--colorCal));
  }

  .paymentMethodRow.selected:hover {
    background-color: var(--colorAli);
  }
  .paymentMethodRow.selected > div {
    border-bottom: none;
    padding: 10px 10px 10px 10px;
  }

  .tokenize-form-slot {
    width: 350px;
  }

  .tokenize-form-host {
    width: 350px;
  }
</style>

<div >

  <!-- if credit card processor -->
  <div>

    <div style="display:flex; flex-direction: row; gap: 20px">
      <app-radio-group
        [name]="paymentOptionRadioName"
        [options]="paymentMethodsOptions"
        [ngModel]="selectedPaymentOptionId"
        (ngModelChange)="onPaymentOptionChanged($event)"
      ></app-radio-group>
    </div>
    <div>
      <app-radio-group
        [name]="paymentOptionRadioName"
        [options]="newPaymentMethodOptions"
        [ngModel]="selectedPaymentOptionId"
        (ngModelChange)="onPaymentOptionChanged($event)"
      ></app-radio-group>
    </div>

    @if (customerId) {
      <div class="tokenize-form-slot">
        <div class="tokenize-form-host" [hidden]="!addingNewPaymentMethod">
          <app-tokenize-form [merchantId]="merchantId" [customerId]="customerId" [paymentType]="achEnabled ? 'ACH' : 'Card'" [hideButtons]="true" (onValidationChange)="handleTokenizeFormValidationChanged($event)" (onTokenized)="handleTokenized($event)"></app-tokenize-form>
          <!-- We can use this if we decide to save the payment method prior to submitting the transaction-->
          <!-- <div>
            <input type="button" value="Save Payment Method" class="button_secondary button_var_2" (click)="onSavePaymentMethodClicked()">
          </div> -->
        </div>
      </div>
    }

  </div>


  <!-- if ACH (TBD)-->
  <div>

  </div>

</div>